import React, { useState } from "react";
import {
	Badge,
	Text,
	Accordion,
	Button,
} from "@website-builder/ui/shared/elements";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";

import { AccordionHeadingWrapper, AccordionContentWrapper } from "./styles";
import { generatePricingOptions } from "./generatePricingOptions";

const PricingAccordion = (props) => {
	const {
		options: { value } = {
			value: {
				options: [],
				scholarship: {
					enable: false,
					text: "",
				},
			},
		},
		pageSection,
	} = props;

	const pricingOptions = {
		scholarship: {
			enable: value?.scholarship?.enable || false,
			text: value?.scholarship?.text || "",
		},
		options: generatePricingOptions(value?.options),
	};

	const [scholarshipKey, setScholarshipKey] = useState(
		pricingOptions?.scholarship?.enable
			? "withScholarship"
			: "withoutScholarship",
	);

	const generateAccordionDetails = () => {
		return pricingOptions?.options.map((option, index) => {
			return {
				key: index,
				heading: <AccordionHeading {...option} />,
				content: <AccordionContent {...option} />,
			};
		});
	};

	const AccordionHeading = ({
		name,
		description,
		actualPrice,
		priceSubtext,
		badge,
	}) => {
		return (
			<AccordionHeadingWrapper>
				<div className="accordion-heading-right-wrapper flex-gap_05">
					<Badge
						className="accordion-pricing-badge"
						text={badge}
						textColor="var(--theme-light-font-color, var(--primary-forest-600))"
						bgColor="var(--theme-secondary, var(--primary-green-400))"
						textVariant="label_M"
					/>
					<Text
						variant="headline_6"
						tag="h3"
						color={{
							base: "primary",
							color: "neutral-nightshade",
							shade: "800",
						}}
					>
						{name}
					</Text>
					<Text
						variant="paragraph_S"
						color={{
							base: "primary",
							color: "neutral-nightshade",
							shade: "600",
						}}
					>
						{description?.[scholarshipKey]}
					</Text>
				</div>
				<div className="accordion-heading-left-wrapper flex-gap_05">
					<div className="accordion-heading-left-price-wrapper flex-gap_05">
						{priceSubtext?.[scholarshipKey]?.position === "left" && (
							<Text
								variant="headline_6"
								tag="span"
								className="accordion-heading-line-through-price"
								color={{
									base: "secondary",
									color: "red",
									shade: "300",
								}}
							>
								{priceSubtext?.[scholarshipKey]?.value}
							</Text>
						)}
						<Text
							variant="headline_6"
							tag="span"
							color={{
								base: "secondary",
								color: "blue",
								shade: "300",
							}}
						>
							{actualPrice?.[scholarshipKey]}
						</Text>
					</div>
					{priceSubtext?.[scholarshipKey]?.position === "bottom" && (
						<Text
							className="below-text"
							variant="paragraph_S"
							color={{
								base: "secondary",
								color: "gray",
								shade: "dark",
							}}
						>
							{priceSubtext?.[scholarshipKey]?.value}
						</Text>
					)}
				</div>
			</AccordionHeadingWrapper>
		);
	};

	const AccordionContent = ({ components, footerText, cta }) => {
		return (
			<AccordionContentWrapper
				footerTextHasMargin={!!(Array.isArray(components) && components.length)}
			>
				{components.map((component, index) => (
					<div
						className="accordion-content"
						key={`${component?.name}+${index}`}
					>
						<Text
							variant="paragraph_S_bold"
							className="accordion-content-text-heading"
							color={{
								base: "primary",
								color: "neutral-nightshade",
								shade: "600",
							}}
						>
							{component?.name}
						</Text>
						<Text
							tag="div"
							variant="paragraph_S"
							className="accordion-content-text-value text-end"
							color={{
								base: "primary",
								color: "neutral-nightshade",
								shade: "600",
							}}
						>
							<div
								className="rich-text-wrapper"
								dangerouslySetInnerHTML={{
									__html: component?.detail?.[scholarshipKey],
								}}
							/>
						</Text>
					</div>
				))}
				{footerText ? (
					<div className="accordion-content footer-text">
						<Text
							variant="paragraph_S"
							tag="div"
							className="rich-text-wrapper"
							color={{
								base: "primary",
								color: "neutral-nightshade",
								shade: "600",
							}}
							dangerouslySetInnerHTML={{ __html: footerText }}
						></Text>
					</div>
				) : null}
				{cta ? (
					<Button
						buttonText={cta?.buttonText}
						type="secondary"
						className="footer-cta"
						onClick={() =>
							handleCTAClick(cta, {
								page_section: pageSection,
								click_text: cta?.buttonText,
								redirect_to: cta?.link?.link,
							})
						}
					/>
				) : null}
			</AccordionContentWrapper>
		);
	};

	return (
		<Accordion
			accordionHeadingClassName={"pricing-accordion-heading"}
			accordionContentClassName={"pricing-accordion-content"}
			showItemTopSeparator={false}
			icon="plusMinus"
			accordionItems={generateAccordionDetails()}
		/>
	);
};

export default PricingAccordion;
